import { SetAdFromUrlInitialState } from '../store/slice/ad-from-url.slice';
import { SetAssetsInitialState, SetAssetsPage } from '../store/slice/assets.slice';
import { SetAuthInitialState } from '../store/slice/auth.slice';
import { SetBrandElementsInitialState } from '../store/slice/brand-elements.slice';
import { SetBrandInitialState } from '../store/slice/brand.slice';
import { SetCampaignAdsInitialState } from '../store/slice/campaign-ads.slice';
import { SetCampaignsInitialState } from '../store/slice/campaign.slice';
import { SetCommonInitialState } from '../store/slice/common.slice';
import { SetEditorInitialState } from '../store/slice/editor.slice';
import { SetOrganizationInitialState } from '../store/slice/organization.slice';
import { SetSessionInitialState } from '../store/slice/session.slice';
import { SetTemplateInitialState } from '../store/slice/template.slice';
import { SetUserInitialState } from '../store/slice/user.slice';

export const setStoreInitialState = (dispatch: any) => {
    dispatch(SetUserInitialState());
    dispatch(SetAuthInitialState());
    dispatch(SetCommonInitialState());
    dispatch(SetEditorInitialState());
    dispatch(SetBrandInitialState());
    dispatch(SetOrganizationInitialState());
    dispatch(SetAssetsInitialState());
    dispatch(SetBrandElementsInitialState());
    dispatch(SetCampaignsInitialState());
    dispatch(SetTemplateInitialState());
    dispatch(SetSessionInitialState());
    dispatch(SetCampaignAdsInitialState());
    dispatch(SetAdFromUrlInitialState());
};

export const setBrandChangeState = (dispatch: any) => {
    dispatch(SetEditorInitialState());
    dispatch(SetAssetsInitialState());
    dispatch(SetBrandElementsInitialState());
    dispatch(SetCampaignsInitialState());
    dispatch(SetAssetsPage(1));
    dispatch(SetSessionInitialState());
    dispatch(SetCampaignAdsInitialState());
};

export const setUserAndAuthInitialState = (dispatch: any) => {
    dispatch(SetUserInitialState());
    dispatch(SetAuthInitialState());
};
